import React, { Component } from 'react'

import styled from 'styled-components'

const StyledNavigator = styled.div`
  position: absolute;
  bottom: 0;
  z-index: 5;
  right: 0;
  display: inline-flex;
  padding: 2rem 4rem;
  @media (max-width: 768px) {
    position: relative;
    padding: 1rem;
    margin: auto;
  }
`
const ArrowCircle = styled.div`
  cursor: pointer;
  padding: 0.65rem 0.55rem;
  border-radius: 50%;
  color: #3c4252;
  background: white;
  margin-left: 0.4rem;
  margin-right: 0.4rem;
  i {
    &:before {
      font-weight: bold;
    }
  }
`

const Navigator = props => {
  let { turnOnBackSpace } = props
  return (
    <StyledNavigator>
      <ArrowCircle
        className="d-lg-none"
        onClick={() => turnOnBackSpace('backward', true)}
      >
        <i className="icon-arrow-left" />
      </ArrowCircle>
      <ArrowCircle
        className="d-lg-none"
        onClick={() => turnOnBackSpace('forward', true)}
      >
        <i className="icon-arrow-right" />
      </ArrowCircle>
      <ArrowCircle
        className="d-none d-lg-block"
        onClick={() => turnOnBackSpace('backward')}
      >
        <i className="icon-arrow-left" />
      </ArrowCircle>
      <ArrowCircle
        className="d-none d-lg-block"
        onClick={() => turnOnBackSpace('forward')}
      >
        <i className="icon-arrow-right" />
      </ArrowCircle>
    </StyledNavigator>
  )
}

export default Navigator



// WEBPACK FOOTER //
// ./src/components/slider/navigator.js